import { render, staticRenderFns } from "./SafeCenter.vue?vue&type=template&id=5c624192&scoped=true&"
import script from "./SafeCenter.vue?vue&type=script&lang=js&"
export * from "./SafeCenter.vue?vue&type=script&lang=js&"
import style0 from "./SafeCenter.vue?vue&type=style&index=0&id=5c624192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c624192",
  null
  
)

export default component.exports